<template>
    <div>
        <Head title="Editar tipo de cliente" />
      <div class="flex justify-start mb-8 max-w-3xl">
        <h1 class="text-3xl font-bold">
          <Link class="text-indigo-400 hover:text-indigo-600" href="/settings/clients/types">Tipos de cliente</Link>
          <span class="text-indigo-400 font-medium">/ Editar</span>
        </h1>
      </div>
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código" />
            <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/3" label="Descripción" />
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar tipo</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
      
  <script>
  import {Head,Link} from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import InputFile from '@/Shared/InputFile'
  import TextInput from '@/Shared/TextInput'
  import TextareaInput from '@/Shared/TextareaInput'
  import FileInput from '@/Shared/FileInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton'
  export default {
    components: {
      InputFile,
      FileInput,
      Head,
      Link,
      LoadingButton,
      SelectInput,
      TextInput,
      TextareaInput,
    },
    layout: Layout,
    props: {
      type: Object,
    },
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          code: this.type.code,
          description: this.type.description,
        }),
      }
    },
    methods: {
      update() {
        this.form.put(`/settings/clients/types/${this.type.id}`)
      },
    },
  }
  </script>
      